var render = function render(){var _vm=this,_c=_vm._self._c;return _c('myechart',_vm._g({attrs:{"options":_vm.chartoption,"mapcity":_vm.mapcity,"mapcode":_vm.mapcode,"echartroll":_vm.echartroll,"maxechartrollnum":_vm.maxechartrollnum,"echartrolltime":_vm.echartrolltime,"orienttype":_vm.orienttype}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }